import api from '../api'

const baseUrl = '/academy/api/AdminFaculty'

const skillUpSupplierProvider = {
  getFaculty(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },

  addFaculty(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  updateFaculty(params = {}) {
    return api.put(`${baseUrl}/Edit`, params)
  },

  updateExtraFaculty(params = {}) {
    return api.put(`${baseUrl}/EditExtraInformation`, params)
  },

  getExtraFaculty() {
    return api.get(`${baseUrl}/GetExtraInformation`)
  },

  deleteFaculty(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },
}

export default skillUpSupplierProvider
